import { tokenColor as utilsTokenColor, colorToRgba as utilsColorToRgba } from '@polleverywhere/viz-utils';
var V1_COLORS = {
    'pe-blue-300': 'rgba(97,147,197,1)',
    'pe-blue-600': 'rgba(53,80,108,1)',
    'pe-blue-700': 'rgba(38,58,78,1)'
};
export function tokenColor(tokenName) {
    if (Object.keys(V1_COLORS).includes(tokenName)) {
        return V1_COLORS[tokenName];
    }
    else {
        return utilsTokenColor(tokenName);
    }
}
export function colorToRgba(color) {
    return utilsColorToRgba(color);
}
